const adminRoutes = [
  {
    path: '/admin',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'allcompanies',
        name: 'admin.allcompanies',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'admin.allcompanies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Admin'
            },
            {
              title: 'All Users',
              active: true
            }
          ],
          pageTitle: 'All Companies',
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'allusers',
        name: 'admin.allusers',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'admin.allusers'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Admin'
            },
            {
              title: 'All Users',
              active: true
            }
          ],
          pageTitle: 'All Users',
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'products',
        name: 'admin.products',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'admin.products'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Admin'
            },
            {
              title: 'Products',
              active: true
            }
          ],
          pageTitle: 'Admin Products',
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'product-features',
        name: 'admin.productFeatures',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'admin.productFeatures'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Admin'
            },
            {
              title: 'Products Features',
              active: true
            }
          ],
          pageTitle: 'Admin Products Features',
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'features',
        name: 'admin.features',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'admin.features'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Admin'
            },
            {
              title: 'Features',
              active: true
            }
          ],
          pageTitle: 'Admin Features',
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'systemusers',
        name: 'admin.systemusers',
        component: () => import('@/views/archistar/admin/SystemUsers.vue'),
        props: {
          scope: 'admin.systemusers'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Admin'
            },
            {
              title: 'System Users',
              active: true
            }
          ],
          pageTitle: 'System Users',
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'rolefeatures',
        name: 'admin.rolefeatures',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'admin.rolefeatures'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Admin'
            },
            {
              title: 'Role Features',
              active: true
            }
          ],
          pageTitle: 'Role Features',
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      }
    ]
  }
];

export default adminRoutes;
